<template>
    <div>
        <div v-if="showSpinner" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div v-else-if="historyItems.length > 0 " class="border-top border-bottom">
            <div class="row mt-2"
                 :class="idx == historyItems.length - 1 ? 'mb-2' : ''"
                 v-for="(itm, idx) in historyItemsToShow"
                 :key="idx">
                <div class="col-5 p-4">
                    <span class="historyText">{{FormatDate(itm.statusDate)}}</span>
                </div>
                <div class="col-7 border-left p-4">
                    <span class="historyText">{{itm.gadgetStatusTypeLabel}}</span>
                    <div v-if="itm.gadgetStatusTypeId == 1000 && itm.excessAmount" class="w-100">
                        <small class="text-muted">Amount: {{itm.excessAmount}} {{itm.currencyCode}}</small>
                    </div>
                    <div v-if="itm.gadgetStatusTypeId == 1001 && itm.paymentAmount" class="w-100">
                        <small class="text-muted">Amount: {{itm.paymentAmount}} {{itm.currencyCode}}</small>
                    </div>
                    <div v-if="itm.gadgetStatusTypeId == 1002 || itm.gadgetStatusTypeId == 1003 || itm.selectedOptionId" class="w-100">
                        <small class="text-muted">Type: {{itm.repairOptionTypeLabel}} ({{itm.repairProviderLabel}})</small>
                    </div>
                    <div v-if="itm.gadgetStatusTypeId == 1005" class="w-100">
                        <small class="text-muted">Pipeline: {{itm.pipelineLabel}} ({{itm.pipelineResult}})</small>
                    </div>
                    <div v-if="itm.gadgetStatusTypeId == 1007 && itm.dispatchTrackingId" class="w-100">
                        <small class="text-muted">Tracking ID: {{ itm.dispatchTrackingId}}</small>
                    </div>
                    <div v-if="itm.gadgetStatusTypeId == 1002 || itm.gadgetStatusTypeId == 1003 || itm.selectedOptionId" class="w-100">
                        <small class="text-muted">Auth ID: {{itm.authorisationId}}</small>
                    </div>
                </div>
            </div>
            <div v-if="historyItems && historyItems.length > 1" class="row">
                <div class="col-12">
                    <a href="javascript:void(0);"
                       @click="showAll = !showAll"
                       class="float-right">{{ showAll == true ? '- Show less' : '+ Show more'}}</a>
                </div>
            </div>
        </div>
        <div v-else>
            <span>Unavailable</span>
        </div>
    </div>
</template>
<script>
    import { gadgetApiService } from '@/services/gadget-api.service'
    import moment from "moment";

    export default {
        name: 'GadgetHistory',
        props: {
            gadgetId: { required: true }
        },
        data: () => {
            return {
                loading: true,
                historyItems: [],
                showAll: true
            }
        },
        computed: {
            showSpinner() {
                if (this.historyItems.length == 0 && this.loading == true) {
                    return true;
                } else {
                    return false;
                }
            },
            historyItemsToShow() {
                if (this.showAll == true) {
                    return this.historyItems
                } else {
                    return [this.historyItems[0]]
                }
            }
        },
        methods: {
            async getGadgetStatusHistory(id) {
                try {
                    gadgetApiService
                        .getHistory(id)
                        .then(response => {
                            let { data } = response.data;
                            if (data && data.length > 0) {
                                this.historyItems = data;
                            }
                            this.loading = false;
                        })
                        .catch(err => {
                            console.log("getGadgetStatusHistory: ", err);
                        });
                } catch (err) {
                    this.loading = false;
                }
            },
            FormatDate(dte) {
                if (dte) return moment(dte).format("DD/MM/YYYY hh:mm A");

                return "UNAVAILABLE";
            }
        },
        mounted() {
            this.getGadgetStatusHistory(this.gadgetId);
        },
    }
</script>
<style scoped>
    .historyText {
        font-size: 1rem;
        font-weight: 300;
    }
</style>